import React, {memo} from "react";
import SwitchItems from "../../../../Components/FormBuilder/Builder/FormInputs/SwitchItems";
// import {getDateFormat} from '../../../../Utils/UserFunctions';
// import moment from "moment";
// import Wrp from '../../../../hoc/Wrp/Wrp';
import {getSelectedValueBasedOnField,isSet} from '../../../../Utils/CommonFunctions';
import { updateLookupFieldDetails,updateLookupFieldDetailsMulti,setFormulaFieldDetails } from "../../../../store/actions/StepsFlowAction";
import { connect } from "react-redux";
import DrillDown from "../../../../Components/DrillDown";
import Buttons from "../../../../Components/UI/Buttons";


const StepsSubFormItem = (props)=>{  
  //console.log('yessssss')
  const {item,modType,columnIndex,keyIndex,isOpenBox,section,subFormIndex,rowIndex,pageType,reminderDisplayText,lookupFieldsData,isPopupWindow} = props;
  let sectionId = section.id;
  
  let styles =  (item.element==='CheckBoxes')?{position:'relative',top:'-16px'}:{};
  let selectedValue = '';
  let overridden = false;
  if(columnIndex!==-1){
    selectedValue = props.selected_value;
    overridden = props.overridden;
  }
  
  // if(item.element==='Date' || item.element==='DateTime'){
  //   console.log('selectedValue',selectedValue,item.label.blocks[0].text);
  //   selectedValue = (isSet(selectedValue,'')!==null)?moment(selectedValue,getDateFormat(item.element)):'';
  // }
  // console.log('item...',item);


  let elementObj = {element_original:item.element}
  if(item.element==='PickList' || item.element==='MultiSelect' || item.element==='User' || item.element==='Lookup' || item.element==='MultiLookup'){ //PickList,Lookup,MultiLookup,User,MultiSelect
    elementObj = {
      element:'CustomAll',
      element_original:item.element,      
    }
  }

  if(item.element==='ImageUpload' || item.element==='FileUpload'){ //ImageUpload,FileUpload
    elementObj = {
      element:'CustomAllFiles',
      element_original:item.element,      
    }
  }

  let updatedItem = {
    ...item,
    selectedValue:selectedValue,
    overridden:overridden,//(item.element==='Date' || item.element==='DateTime')?true:
    //id:item.id+'_'+rowIndex+'_'+rowData.id,
    modType:modType,
    ...elementObj
  }  

  //console.log('updatedItem==',updatedItem)

  // my code 07
  const updateValuesObjectHandler = (field,val)=>{
    //console.log('updateValuesObjectHandler==',field,val)
    const {id} = field;
    //api_custom_field_name
    const dispName = [];
    let selectedId = '';
    isSet(val,[]).map((dItem)=>{
        dispName.push(dItem.field_name);
        selectedId = dItem.id;
    });
    // console.log('dispName',dispName);
    const updateVal= (isSet(val,[]).length>0)?val[isSet(val,[]).length-1].window_field_id_path:'';
    let isLoop = isSet((isSet(val,[]).length>0)?isSet(isSet(val,[])[0].dependent_layout,{is_loop:false}).is_loop:false,false);
    let expression = [];
    let selectedValue = updateVal;
    if(isLoop===true){
        isSet(val,[]).map((expItm,expItmIndex)=>{
            if(expItmIndex===0 && expItm.dependent_layout.window_name){
                expression.push(expItm.dependent_layout.window_name)
            }
            if(isSet(expItm.api_field_name,null)!==null){
                expression.push(expItm.api_field_name);
            }
            selectedId = expItm.id
        })
        selectedValue=  '${'+expression.join('.')+'}';
    }
    const isVariableOrConstant = (isSet(val,[]).length>0)?
    isSet(isSet(val,[])[0].is_variable_or_constant,isSet(isSet(isSet(val,[])[0].dependent_layout,{is_variable_or_constant:false}).is_variable_or_constant,false))
        :false;

    if(isVariableOrConstant===true){
        selectedValue = selectedId;
    }

    const returnValue = [{
        name:dispName.join('.'),
        data_id:isSet((isSet(val,[]).length>0)?isSet(isSet(val,[])[0].dependent_layout,{data_id:null}).data_id:null,null),
        is_loop:isLoop,
        value:selectedValue,
        is_window_field:(isLoop===true && isVariableOrConstant===false)?true:false,
        is_variable_or_constant:isVariableOrConstant,
    }];

        //console.log('returnValue==',returnValue)        
    props.updateLookupFieldDetailsMulti(sectionId,rowIndex,id,returnValue); 
  }

  const updateValueHandler = (field,e,type='TextInput',obj)=>{    
    // console.log('updateValueHandler==',type,e)
    // console.log('obj===',obj)
    const {id} = field;
    let fieldValue = null;
    let displayName = null;
    if(type==='MultiSelect'){
        let MultiSelectValue = [];
        e = (e===null)?[]:e;
        e.map((item)=>{
            MultiSelectValue.push(item.id);
                return item;
        }); 
        fieldValue = MultiSelectValue.join(',');
    }else if(type==='CheckBoxes'){
        fieldValue = e.target.checked;
    }else if(type==='date'){
        fieldValue = isSet(e,'');
    }else if(['number','phoneNumber','PickList'].indexOf(type)!==-1){
        fieldValue = e
    }else if(['Lookup','MultiLookup'].indexOf(type)!==-1){
        fieldValue = e.selectedValue;
        displayName = e.displayValue;
        // console.log('e',e);
    }else if(type==='Files'){
        fieldValue = e;
    }else if(type==='Reminder'){
        fieldValue = e;
    }else if(type==='CustomAllSingle'){
        fieldValue = e;
    }else if(type==='CustomAllArray'){
        let MultiArrayValue = [];
        e = (e===null)?[]:e;
        e.map((item)=>{
          MultiArrayValue.push(item.id);
          return item;
        }); 
        fieldValue = MultiArrayValue.join(',');
    }else{ 
        fieldValue = e.target.value;
    }
    const returnValue = [{
        name:'',
        data_id:'',
        is_loop:false,
        value:fieldValue,
        is_window_field:false,
        is_variable_or_constant:false,
    }]
    let sectionId = obj.sectionId;
    //console.log('updateLookupFieldDetailsMulti==',sectionId,id,returnValue)
    props.updateLookupFieldDetailsMulti(sectionId,obj.rowIndex,id,returnValue);
  }

  const editHandler = () => {}

  const removeHandler = (field)=>{
    const {id} = field;
    const returnValue = [{
        name:'',
        data_id:'',
        is_loop:false,
        value:'',
        is_window_field:false,
        is_variable_or_constant:false,
    }];
    //console.log('removeHandler===',sectionId,rowIndex,id,returnValue)
    //console.log(field);
    props.updateLookupFieldDetailsMulti(sectionId,rowIndex,id,returnValue); 
  }

  
  
  try{    
    //console.log('rendereee')
    let selectedValue = item.selectedValue;
    let elementType = item.element;
    
    if(item.element==='PickList' || item.element==='MultiSelect' || item.element==='User' || item.element==='Lookup' || item.element==='MultiLookup'){ //PickList,Lookup,MultiLookup,User,MultiSelect
        elementType='CustomAll';
    }
    if(item.element==='ImageUpload' || item.element==='FileUpload'){ //ImageUpload,FileUpload
        elementType='CustomAllFiles'    
    }
    let isEditEnable = false;
    //console.log('item.selectedValue==111',props.valuesObject[sectionId][0],sectionId) 
    if(isSet(props.valuesObject[sectionId][0][item.id][0].is_loop,false)===true || isSet(props.valuesObject[sectionId][0][item.id][0].is_variable_or_constant,false)===true){
        //console.log('item.selectedValue==22',item) 
        selectedValue = isSet(props.valuesObject[sectionId][0][item.id][0].name,null);
        elementType = 'StepsTypeTag';
    }else if(isSet(props.valuesObject[sectionId][0][item.id][0].is_expression,false)===true){
        //console.log('item.selectedValue==333',item) 
        selectedValue = isSet(props.valuesObject[sectionId][0][item.id][0].name,null);
        elementType = 'StepsTypeTag';
        isEditEnable = true;
        editHandler = ()=>props.setFormulaFieldDetails({
                    value:(isSet(props.valuesObject[sectionId][0][item.id],[]).length)>0?isSet(props.valuesObject[sectionId][0][item.id][0],{}).value:'',
                    conValue:isSet(props.valuesObject[sectionId][0][item.id],[{
                        name:'',
                        data_id:'',
                        is_loop:false,
                        value:'',
                        is_window_field:false,
                        is_variable_or_constant:false,
                        is_expression:true
                    }]),
                    itmValIndex:0,
                    drillDownOptions:lookupFieldsData.lookupFields.drillDownOptions,
                    updateVariables:(itmIndex,key,val)=>props.updateLookupFieldDetailsMulti(sectionId,rowIndex,item.id,val),
                    conIndex:0,
                },true)
    }
    else if(isSet(props.valuesObject[sectionId][0][item.id][0].is_loop,false)===false || isSet(props.valuesObject[sectionId][0][item.id][0].is_variable_or_constant,false)===false){
        selectedValue = isSet(props.valuesObject[sectionId][0][item.id][0].value,null)
    }
        updatedItem = {
            ...updatedItem,
            element:elementType,
            isEditEnable:isEditEnable,
            editHandler:editHandler,
            removeHandler:removeHandler,
            selectedValue:selectedValue,//isSet(props.valuesObject[item.id][0].name,null),
            reminder:isSet(props.valuesObject[sectionId][0][item.id][0].value,''),
        }

        //console.log('selectedValue Subform==',selectedValue)
      
  }catch(e){
    // console.log('exc',e);
  }

  const btnGroup = [{ 
      isButtonGroup:true,
      className:'input-group-text pl-2 pr-2',
      style:{},
      list:[
      {
          href:"",
          attributes:{
          className:"border-default dropdown-toggle  dropdown-menu-right hidden-caret",
          'data-toggle':'dropdown',
          'aria-expanded':'false'
          },
          name:"",
          svgIcon:'EllipsisV',
          children:{
              attributes:{
              className:"dropdown-menu dropdown-menu-right"
              },
              style:{
              position:'absolute',
              transform: 'translate3d(-44px, 33px, 0px)', 
              top: '0px',
              left: '0px', 
              willChange: 'transform'
              },
              buttonList:[{
                  name:'Add Formula',
                  attributes:{
                      className:'dropdown-item'
                  },
                  clickHandler:()=>props.setFormulaFieldDetails({
                      value:(isSet(props.valuesObject[sectionId][0][item.id],[]).length)>0?isSet(props.valuesObject[sectionId][0][item.id][0],{}).value:'',
                      conValue:isSet(props.valuesObject[sectionId][0][item.id],[{
                          name:'',
                          data_id:'',
                          is_loop:false,
                          value:'',
                          is_window_field:false,
                          is_variable_or_constant:false,
                          is_expression:true
                      }]),
                      itmValIndex:0,
                      drillDownOptions:lookupFieldsData.lookupFields.drillDownOptions,
                      updateVariables:(itmIndex,key,val)=>{console.log('val',val); props.updateLookupFieldDetailsMulti(sectionId,rowIndex,item.id,val)},
                      conIndex:0,
                  },true)
              }]
              }
          }
      ]
  }]  
  // ends


  const fieldObj = {
    section_index:section.section_index,
    sectionId:section.id,
    itemIndex:item.itemIndex,
    modType:modType,
    item:updatedItem,
    rowIndex:rowIndex,
    subFormIndex:subFormIndex,
    columnIndex:columnIndex
  }

  return(
    <td className="" key={keyIndex}>
      {(isOpenBox==true || pageType==='form')?
        <div style={{...styles}}>
          <SwitchItems 
              {...props}
              layoutForms={true}
              formType={'SUBFORM'}
              modType={'ADDFORM'}
              fieldObj={fieldObj}
              isPopupWindow={isPopupWindow}
              item={updatedItem} 
              reminderDisplayText={reminderDisplayText}
              // section={section}
              appendBlocks={(item.element==='CheckBoxes' || item.element==='ImageUpload' || item.element==='FileUpload' || item.element==='Reminder')?
              <></>:
              <div className='input-group-append cursor-pointer'>
                   <DrillDown 
                      drillId={"drill_"+item.id} 
                      selectedValue={[]} 
                      hocClass='input-group-text'
                      fieldDetails={lookupFieldsData.lookupFields.drillDownOptions} 
                      selectHandler={(val)=>updateValuesObjectHandler(item,val)}
                      isConditionApplied={true}
                      isCustomChildren={true} >
                  <span className="input-group-text" style={{height:'100%',display:'block',border:'0px'}}>
                      <i className="fas fa-search primary_color"></i>
                  </span>
                  </DrillDown>
                  <Buttons buttonList={btnGroup} />
              </div>
              }
              onChangeInputAction={(obj,val,type)=>{
                  props.onChangeInputAction(obj,val,type);
                  updateValueHandler(item,val,type,obj);
              }}
          />
          </div>
         :getSelectedValueBasedOnField(updatedItem) }
        
  </td>
  )
}

// const isDiffProps = (prevProps, nextProps) => {
//   if (
//     prevProps.currencyCode === nextProps.currencyCode &&
//     isEqual(prevProps.selectedValue, nextProps.selectedValue) &&
//     isEqual(prevProps.options, nextProps.options) &&
//     prevProps.item.access_mode === nextProps.item.access_mode &&
//     prevProps.item.required === nextProps.item.required &&
//     prevProps.isOpenBox === nextProps.isOpenBox &&
//     isEqual(prevProps.subformValidation[prevProps.item.id], nextProps.subformValidation[nextProps.item.id])
//   ) {
//     return true; 
//   }

//   return false; 
// };

//export default memo(StepsSubFormItem,isDiffProps);

const mapStateToProps = (state,props) => { 
    return {
        lookupFieldsData:state.StepsFlowReducer.lookupFieldsData,
        valuesObject:state.StepsFlowReducer.lookupFieldsData.valuesObject,
        //  formulaFieldData:state.StepsFlowReducer.formulaFieldData
    };
  }

const mapDispatchToProps = dispatch => {
    return {
      setFormulaFieldDetails:(obj,bool)=>dispatch(setFormulaFieldDetails(obj,bool)),
      updateLookupFieldDetails:(obj,val)=>dispatch(updateLookupFieldDetails(obj,val)),
      updateLookupFieldDetailsMulti:(sectionId,rowIndex,obj,val)=>dispatch(updateLookupFieldDetailsMulti(sectionId,rowIndex,obj,val))     
    };
}
export default
    connect(
      mapStateToProps, 
      mapDispatchToProps
    )(memo(StepsSubFormItem));
